import {PREVIOUS_MEETINGS} from "../previous-meetings-widget.consts";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {PreviousMeetingsWidgetState} from "../models/previous-meetings-widget.state";

export class PreviousMeetingsWidgetToggleCollapsedHandler extends ActionHandler {
  state: PreviousMeetingsWidgetState;
  type = PREVIOUS_MEETINGS.ACTION_TYPES.toggleCollapsed;

  async action(params) {
    this.state.isExpanded = !this.state.isExpanded;
  }
}
